import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../useAuth";
import { useSessions } from "../../api/Sessions";
import moment from "moment";
import SessionDisplayList from "../../components/Session/SessionDisplayList";
import Loading from "../../components/Loading";
import { ContentTitle } from "../../layout/ContentLayout";

const UserSessions = () => {
  const [upcoming, setUpcoming] = useState();
  const [past, setPast] = useState();

  const queryDate = moment().subtract(30, "days").startOf("day").toISOString();
  const { user } = useContext(AuthContext);
  const { data, isLoading } = useSessions(user?.UserId, {
    startTime: queryDate,
  });

  useEffect(() => {
    if (data?.sessions) {
      let sorted = organizationSessions(data.sessions);
      setUpcoming(sorted.upcoming);
      setPast(sorted.past);
    }
  }, [data]);

  return (
    <>
      <ContentTitle>My Sessions</ContentTitle>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <SessionDisplayList title="Upcoming Sessions" sessions={upcoming} />
          <SessionDisplayList title="Past Sessions" sessions={past} />
        </>
      )}
    </>
  );
};

const organizationSessions = (sessions) => {
  let upcoming = [],
    past = [];
  const now = moment().utc();

  sessions?.forEach((s) => {
    const { session } = s;
    let start = moment(session?.EndTime);
    if (start.isAfter(now)) upcoming.push(s);
    else past.push(s);
  });

  return {
    upcoming: upcoming.sort((a, b) => (a.StartTime < b.StartTime ? -1 : 1)),
    past: past,
  };
};

export default UserSessions;
